import axios from 'axios';
import { req } from './axiosFun';
// 创建报告
export const CreateReport = (params) => { return req("post", "https://api.cstac.cn/api/report/creat" , params) };
//报告列表
export const ReportList = () => { return req("get", "https://api.cstac.cn/api/reportall" , null) };
//修改报告
export const UpdateReport = (params) => { return req("post", "https://api.cstac.cn/api/report/update" , params) };
//查询单个报告
export const reportOne = (params) => { return req("post", "https://api.cstac.cn/api/report/update/"+ params , null) };
//删除报告
export  const delReport = (params) => {
    return axios({
        method: 'post',
        url: 'https://api.cstac.cn/api/report/del',
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
            Authorization: localStorage.getItem('logintoken')
        },
        data: params,
    }).then(res => res.data);
 };
 //模糊查询报告列表
export const FindReportList = (params) => {
    // return req("post", "http://45.119.52.226:8090/api/report/find" , params)
    return axios({
        method: 'post',
        url: 'https://api.cstac.cn/api/report/find',
        headers: {
            // 'Content-Type': 'application/x-www-form-urlencoded',
            'Content-Type': 'multipart/form-data; boundary=<calculated when request is sent>',
            Authorization: localStorage.getItem('logintoken')
        },
        data: params,
    }).then(res => res.data);
};



// WEBPACK FOOTER //
// ./src/api/report.js